class DownloadPopup {
    constructor() {
        this.downloadBtn = document.querySelector('.download-btn');
        this.popup = document.querySelector('.downloads-popup');
        this.events();
    }

    events() {
        if(this.downloadBtn) {
            this.downloadBtn.addEventListener('click', () => this.togglePopup());
        }
    }

    togglePopup() {
        this.popup.style.display = this.popup.style.display === 'none' ? 'block' : 'none';
    }
}

export default DownloadPopup;
